import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { isEmpty } from 'lodash'

import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { FormattedDuration } from '@10xLabs/react-web/components/FormattedDuration'
import { FormattedNumber } from '@10xLabs/react-web/components/FormattedNumber'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { round } from 'utils/math'
import { drawerType } from 'types/drawer'
import { useLogin } from 'features/Login/hooks'
import { canReadDrawerBookings, canReadDrawerKreditSales, canReadDrawerSales } from 'features/Users/utils'

const TicketWrapper = styled.div<TSFixMe>`
  color: #000000;
  max-width: 210px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 100px;
  padding: 20px 0;
  font-size: 10px;
`

const Title = styled.h1<TSFixMe>`
  text-align: center;
  font-size: 11px;
  margin: 0 0 20px;
`

const Duration = styled.div<TSFixMe>`
  margin-top: 5px;
  display: inline-flex;
  font-weight: normal;
`

const DurationLabel = styled.div<TSFixMe>`
  margin-right: 3px;
`

const Timeframe = styled.div<TSFixMe>`
  margin-bottom: 10px;
`

const DatetimeWrapper = styled.div<TSFixMe>`
  display: flex;
`

const FirstLetterCapitalize = styled.div<TSFixMe>`
  ::first-letter {
    text-transform: capitalize;
  }
`

const DatetimeSeparator = styled.div<TSFixMe>`
  margin-right: 3px;
`

const TimeframeTable = styled.table<TSFixMe>`
  border-collapse: collapse;
`

const SpaceBetwen = styled.div<TSFixMe>`
  display: flex;
  justify-content: space-between;
`

const TimeframeLabel = styled(SpaceBetwen)<TSFixMe>`
  text-transform: uppercase;
`

const SalesAgent = styled.div<TSFixMe>`
  margin-bottom: 10px;
`

const AmountList = styled.div<TSFixMe>`
  margin-bottom: 10px;

  :last-child {
    margin-bottom: 5px;
  }
`

const AmountListTitle = styled.div<TSFixMe>`
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 10px;
`

const AmountSeparator = styled.div<TSFixMe>`
  border-top: 1px dashed rgba(0, 0, 0, 0.85);
  margin-bottom: 5px;
`

const AmountTableWrapper = styled.div<TSFixMe>`
  margin-left: 10px;
`

const AmountTable = styled.table<TSFixMe>`
  border-collapse: collapse;
  width: 100%;
`

const AmountLabel = styled.td<TSFixMe>`
  width: 50%;
`

const TotalAmountLabel = styled(AmountLabel)<TSFixMe>`
  text-align: right;
  text-transform: uppercase;
  padding-top: 10px;
`

const AmountValue = styled.td<TSFixMe>`
  width: 50%;
  text-align: right;
`

const TotalAmountValue = styled(AmountValue)<TSFixMe>`
  font-weight: 500;
  padding-top: 10px;
`

const StatisticsTitle = styled.div<TSFixMe>`
  text-transform: uppercase;
  margin-bottom: 10px;
`

const StatisticsTable = styled.table<TSFixMe>`
  border-collapse: collapse;
`

const StatisticsLabel = styled.td<TSFixMe>`
  padding: 0 5px 0 10px;
`

const StatisticsValue = styled.td<TSFixMe>`
  padding: 0 0 0 5px;
`

const SignaturesWrapper = styled.div<TSFixMe>`
  display: flex;
  margin-top: 40px;
  justify-content: space-around;
`

const SignatureLabel = styled.div<TSFixMe>`
  text-transform: uppercase;
`

const PrintingDateWrapper = styled.div<TSFixMe>`
  margin: 20px 0;
`

const DEFAULT_AMOUNTS = {
  cash: 0,
  card: 0
}

const ReportToPrint = ({ drawerToPrint = {} }): TSFixMe => {
  // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
  const { site = {}, user = {}, endTime, startTime, receiptData, company } = drawerToPrint
  const intl = useIntl()
  const login = useLogin()
  const { policies } = login.accessToken

  if (isEmpty(site) || !endTime) return null

  const now = new Date()
  const startAt = new Date(startTime)
  const endAt = new Date(endTime)
  const duration = endAt.getTime() - startAt.getTime()
  const bookingsAmount = canReadDrawerBookings(policies) ? receiptData.expectedAmount.bookings : DEFAULT_AMOUNTS
  const salesAmount = canReadDrawerSales(policies) ? receiptData.expectedAmount.sales : DEFAULT_AMOUNTS
  const mobileSalesAmount = canReadDrawerSales(policies) ? receiptData.expectedAmount.mobileSales : DEFAULT_AMOUNTS
  const kreditSalesAmount = canReadDrawerKreditSales(policies)
    ? receiptData.expectedAmount.kreditSales
    : DEFAULT_AMOUNTS
  return (
    <TicketWrapper>
      <Title>
        <div>{site.name}</div>
        <div>{company && company.name}</div>
        <div>
          <Duration>
            <DurationLabel>
              <FormattedMessage id="report.print.duration" defaultMessage="Duración :" />
            </DurationLabel>
            <FormattedDuration duration={round(duration / (1000 * 60))} />
          </Duration>
        </div>
      </Title>
      <Timeframe>
        <TimeframeTable>
          <tbody>
            <tr>
              <td>
                <TimeframeLabel>
                  <FormattedMessage id="report.print.start" defaultMessage="Inicio" />
                  <div>:</div>
                </TimeframeLabel>
              </td>
              <td>
                <DatetimeWrapper>
                  <FirstLetterCapitalize>
                    <FormattedDate value={startAt} weekday="long" year="2-digit" month="2-digit" day="2-digit" />
                  </FirstLetterCapitalize>
                  <DatetimeSeparator>,</DatetimeSeparator>
                  <FormattedTimeByDate intl={intl} date={startAt} />
                </DatetimeWrapper>
              </td>
            </tr>
            <tr>
              <td>
                <TimeframeLabel>
                  <FormattedMessage id="report.print.end" defaultMessage="Fin" />
                  <div>:</div>
                </TimeframeLabel>
              </td>
              <td>
                <DatetimeWrapper>
                  <FirstLetterCapitalize>
                    <FormattedDate value={endAt} weekday="long" year="2-digit" month="2-digit" day="2-digit" />
                  </FirstLetterCapitalize>
                  <DatetimeSeparator>,</DatetimeSeparator>
                  <FormattedTimeByDate intl={intl} date={endAt} />
                </DatetimeWrapper>
              </td>
            </tr>
          </tbody>
        </TimeframeTable>
      </Timeframe>
      <SalesAgent>
        <FormattedMessage
          id="report.print.salesAgent"
          defaultMessage="VENDEDOR : {salesAgent}"
          values={{
            salesAgent: `${user.firstName} ${user.lastName}`
          }}
        />
      </SalesAgent>
      <div>
        {canReadDrawerBookings(policies) && (
          <AmountList>
            <AmountListTitle>
              <FormattedMessage
                id="drawers.receipt.bookings.amountToReceive"
                defaultMessage="Cantidad por recibir - boletos:"
              />
            </AmountListTitle>
            <AmountTableWrapper>
              <AmountTable>
                <tbody>
                  <tr>
                    <AmountLabel>
                      <SpaceBetwen>
                        <FormattedMessage id="dictionary.cash" defaultMessage="Efectivo" />
                        <div>:</div>
                      </SpaceBetwen>
                    </AmountLabel>
                    <AmountValue>
                      <FormattedPrice value={bookingsAmount.cash} noSmallCurrency />
                    </AmountValue>
                  </tr>
                  <tr>
                    <AmountLabel>
                      <SpaceBetwen>
                        <FormattedMessage id="dictionary.card" defaultMessage="Tarjeta" />
                        <div>:</div>
                      </SpaceBetwen>
                    </AmountLabel>
                    <AmountValue>
                      <FormattedPrice value={bookingsAmount.card} noSmallCurrency />
                    </AmountValue>
                  </tr>
                  <tr>
                    <TotalAmountLabel>
                      <FormattedMessage id="report.print.total" defaultMessage="Total :" />
                    </TotalAmountLabel>
                    <TotalAmountValue>
                      <FormattedPrice value={bookingsAmount.cash + bookingsAmount.card} noSmallCurrency />
                    </TotalAmountValue>
                  </tr>
                </tbody>
              </AmountTable>
            </AmountTableWrapper>
          </AmountList>
        )}
        {canReadDrawerSales(policies) && (
          <AmountList>
            <AmountListTitle>
              <FormattedMessage
                id="drawers.receipt.sales.amountToReceive"
                defaultMessage="Cantidad por recibir - snacks:"
              />
            </AmountListTitle>
            <AmountTableWrapper>
              <AmountTable>
                <tbody>
                  <tr>
                    <AmountLabel>
                      <SpaceBetwen>
                        <FormattedMessage id="dictionary.cash" defaultMessage="Efectivo" />
                        <div>:</div>
                      </SpaceBetwen>
                    </AmountLabel>
                    <AmountValue>
                      <FormattedPrice value={salesAmount.cash + mobileSalesAmount.cash} noSmallCurrency />
                    </AmountValue>
                  </tr>
                  <tr>
                    <AmountLabel>
                      <SpaceBetwen>
                        <FormattedMessage id="dictionary.card" defaultMessage="Tarjeta" />
                        <div>:</div>
                      </SpaceBetwen>
                    </AmountLabel>
                    <AmountValue>
                      <FormattedPrice value={salesAmount.card + mobileSalesAmount.card} noSmallCurrency />
                    </AmountValue>
                  </tr>
                  <tr>
                    <TotalAmountLabel>
                      <FormattedMessage id="report.print.total" defaultMessage="Total :" />
                    </TotalAmountLabel>
                    <TotalAmountValue>
                      <FormattedPrice
                        value={salesAmount.cash + salesAmount.card + mobileSalesAmount.cash + mobileSalesAmount.card}
                        noSmallCurrency
                      />
                    </TotalAmountValue>
                  </tr>
                </tbody>
              </AmountTable>
            </AmountTableWrapper>
          </AmountList>
        )}
        {canReadDrawerKreditSales(policies) && (
          <AmountList>
            <AmountListTitle>
              <FormattedMessage
                id="drawers.receipt.kreditSales.amountToReceive"
                defaultMessage="Cantidad por recibir - credits:"
              />
            </AmountListTitle>
            <AmountTableWrapper>
              <AmountTable>
                <tbody>
                  <tr>
                    <AmountLabel>
                      <SpaceBetwen>
                        <FormattedMessage id="dictionary.cash" defaultMessage="Efectivo" />
                        <div>:</div>
                      </SpaceBetwen>
                    </AmountLabel>
                    <AmountValue>
                      <FormattedPrice value={kreditSalesAmount.cash} noSmallCurrency />
                    </AmountValue>
                  </tr>
                  <tr>
                    <AmountLabel>
                      <SpaceBetwen>
                        <FormattedMessage id="dictionary.card" defaultMessage="Tarjeta" />
                        <div>:</div>
                      </SpaceBetwen>
                    </AmountLabel>
                    <AmountValue>
                      <FormattedPrice value={kreditSalesAmount.card} noSmallCurrency />
                    </AmountValue>
                  </tr>
                  <tr>
                    <TotalAmountLabel>
                      <FormattedMessage id="report.print.total" defaultMessage="Total :" />
                    </TotalAmountLabel>
                    <TotalAmountValue>
                      <FormattedPrice value={kreditSalesAmount.cash + kreditSalesAmount.card} noSmallCurrency />
                    </TotalAmountValue>
                  </tr>
                </tbody>
              </AmountTable>
            </AmountTableWrapper>
          </AmountList>
        )}
        <AmountList>
          <AmountListTitle>
            <FormattedMessage id="report.print.receivedAmount" defaultMessage="Cantidad recibida:" />
          </AmountListTitle>
          <AmountTableWrapper>
            <AmountTable>
              <tbody>
                <tr>
                  <AmountLabel>
                    <SpaceBetwen>
                      <FormattedMessage id="dictionary.cash" defaultMessage="Efectivo" />
                      <div>:</div>
                    </SpaceBetwen>
                  </AmountLabel>
                  <AmountValue>
                    <FormattedPrice value={receiptData.actualAmount.cash} noSmallCurrency />
                  </AmountValue>
                </tr>
                <tr>
                  <AmountLabel>
                    <SpaceBetwen>
                      <FormattedMessage id="dictionary.card" defaultMessage="Tarjeta" />
                      <div>:</div>
                    </SpaceBetwen>
                  </AmountLabel>
                  <AmountValue>
                    <FormattedPrice value={receiptData.actualAmount.card} noSmallCurrency />
                  </AmountValue>
                </tr>
                <tr>
                  <TotalAmountLabel>
                    <FormattedMessage id="report.print.total" defaultMessage="Total :" />
                  </TotalAmountLabel>
                  <TotalAmountValue>
                    <FormattedPrice
                      value={receiptData.actualAmount.cash + receiptData.actualAmount.card}
                      noSmallCurrency
                    />
                  </TotalAmountValue>
                </tr>
              </tbody>
            </AmountTable>
          </AmountTableWrapper>
        </AmountList>
      </div>
      <AmountSeparator />
      <div>
        <AmountList>
          <AmountListTitle>
            <FormattedMessage id="report.print.difference" defaultMessage="Diferencia:" />
          </AmountListTitle>
          <AmountTableWrapper>
            <AmountTable>
              <tbody>
                <tr>
                  <AmountLabel>
                    <SpaceBetwen>
                      <FormattedMessage id="dictionary.cash" defaultMessage="Efectivo" />
                      <div>:</div>
                    </SpaceBetwen>
                  </AmountLabel>
                  <AmountValue>
                    <FormattedPrice
                      value={
                        receiptData.actualAmount.cash -
                        (bookingsAmount.cash + salesAmount.cash + mobileSalesAmount.cash + kreditSalesAmount.cash)
                      }
                      noSmallCurrency
                    />
                  </AmountValue>
                </tr>
                <tr>
                  <AmountLabel>
                    <SpaceBetwen>
                      <FormattedMessage id="dictionary.card" defaultMessage="Tarjeta" />

                      <div>:</div>
                    </SpaceBetwen>
                  </AmountLabel>
                  <AmountValue>
                    <FormattedPrice
                      value={
                        receiptData.actualAmount.card -
                        (bookingsAmount.card + salesAmount.card + mobileSalesAmount.card + kreditSalesAmount.card)
                      }
                      noSmallCurrency
                    />
                  </AmountValue>
                </tr>
              </tbody>
            </AmountTable>
          </AmountTableWrapper>
        </AmountList>
      </div>
      <AmountSeparator />
      <StatisticsTitle>
        <FormattedMessage id="drawers.receipt.statistics" defaultMessage="Estadisticas" />
      </StatisticsTitle>
      <StatisticsTable>
        <tbody>
          <tr>
            <StatisticsLabel>
              <FormattedMessage
                id="drawers.receipt.totalStatistic.confirmedTickets"
                defaultMessage="Total de {confirmedTickets, plural,
                  one {confirmado}
                  other {confirmados}
                }"
                values={{
                  confirmedTickets: receiptData.ticketsByStatus.confirmed
                }}
              />
            </StatisticsLabel>
            <td>:</td>
            <StatisticsValue>
              <FormattedNumber value={receiptData.ticketsByStatus.confirmed} />
            </StatisticsValue>
          </tr>
          <tr>
            <StatisticsLabel>
              <FormattedMessage
                id="drawers.receipt.totalStatistic.cancelledTickets"
                defaultMessage="Total de {cancelledTickets, plural,
                  one {cancelado}
                  other {cancelados}
                }"
                values={{
                  cancelledTickets: receiptData.ticketsByStatus.cancelled
                }}
              />
            </StatisticsLabel>
            <td>:</td>
            <StatisticsValue>
              <FormattedNumber value={receiptData.ticketsByStatus.cancelled} />
            </StatisticsValue>
          </tr>
        </tbody>
      </StatisticsTable>
      <PrintingDateWrapper>
        <TimeframeTable>
          <tbody>
            <tr>
              <td>
                <TimeframeLabel>
                  <FormattedMessage id="drawers.receipt.now.label" defaultMessage="Impresión" />
                  <div>:</div>
                </TimeframeLabel>
              </td>
              <td>
                <DatetimeWrapper>
                  <FirstLetterCapitalize>
                    <FormattedDate value={now} weekday="long" year="2-digit" month="2-digit" day="2-digit" />
                  </FirstLetterCapitalize>
                  <DatetimeSeparator>,</DatetimeSeparator>
                  <FormattedTimeByDate intl={intl} date={now} />
                </DatetimeWrapper>
              </td>
            </tr>
          </tbody>
        </TimeframeTable>
      </PrintingDateWrapper>
      <SignaturesWrapper>
        <SignatureLabel>
          <FormattedMessage id="report.print.signature.saleAgent" defaultMessage="Vendedor" />
        </SignatureLabel>
        <div>|</div>
        <SignatureLabel>
          <FormattedMessage id="report.print.signature.responsable" defaultMessage="Responsable" />
        </SignatureLabel>
      </SignaturesWrapper>
    </TicketWrapper>
  )
}

ReportToPrint.propTypes = {
  drawerToPrint: drawerType
}

export { ReportToPrint }
